import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.regexp.replace";
import React from 'react';
import PropTypes from 'prop-types';
var n = .2126,
    r = .7152,
    t = .0722,
    e = 1 / 12.92;

function u(n) {
  return Math.pow((n + .055) / 1.055, 2.4);
}

function a(a) {
  var i = a[0] / 255,
      c = a[1] / 255,
      o = a[2] / 255,
      s = i <= .03928 ? i * e : u(i),
      f = c <= .03928 ? c * e : u(c),
      l = o <= .03928 ? o * e : u(o);
  return s * n + f * r + l * t;
}

function i(n) {
  var r = 255;
  8 === (n = n.replace(/^#/, "")).length && (r = parseInt(n.slice(6, 8), 16), n = n.substring(0, 6)), 4 === n.length && (r = parseInt(n.slice(3, 4).repeat(2), 16), n = n.substring(0, 3)), 3 === n.length && (n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2]);
  var t = parseInt(n, 16);
  return [t >> 16, t >> 8 & 255, 255 & t, r];
}

function c(n, r) {
  return (Math.max(n, r) + .05) / (Math.min(n, r) + .05);
}

function o(n, r) {
  return c(a(n), a(r));
}

function s(n, r) {
  return o(i(n), i(r));
}

function f(n) {
  return n >= 7 ? "AAA" : n >= 4.5 ? "AA" : n >= 3 ? "AA Large" : "Fail";
}

var index_m = /*#__PURE__*/Object.freeze({
  luminance: c,
  rgb: o,
  hex: s,
  score: f
});
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var colorcolor_1 = createCommonjsModule(function (module) {
  /*jshint esversion: 6 */
  function colorcolor(color) {
    var newColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "rgba";
    var calculateOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    color = color.toLowerCase();
    newColor = newColor.toLowerCase();
    var returnedColor = color;
    var namedColor = colorName;
    var r, g, b, a;
    var roundTo = 4;
    var colorDefinitions = {
      rgb: {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1], 10), parseInt(bits[2], 10), parseInt(bits[3], 10), 1];
        }
      },
      rgba: {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d+(?:\.\d+)?|\.\d+)\s*\)/,
        example: ["rgba(123, 234, 45, 1)", "rgba(255,234,245, 0.5)"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1], 10), parseInt(bits[2], 10), parseInt(bits[3], 10), parseFloat(bits[4])];
        }
      },
      hex: {
        re: /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["00ff00", "336699"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1], 16), parseInt(bits[2], 16), parseInt(bits[3], 16), 1];
        }
      },
      hex3: {
        re: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["fb0", "f0f"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1] + bits[1], 16), parseInt(bits[2] + bits[2], 16), parseInt(bits[3] + bits[3], 16), 1];
        }
      },
      hexa: {
        re: /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["00ff00ff", "336699a0"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1], 16), parseInt(bits[2], 16), parseInt(bits[3], 16), parseInt(bits[4], 16) / 255];
        }
      },
      hex4a: {
        re: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["fb0f", "f0f8"],
        toRGBA: function toRGBA(bits) {
          return [parseInt(bits[1] + bits[1], 16), parseInt(bits[2] + bits[2], 16), parseInt(bits[3] + bits[3], 16), parseInt(bits[4] + bits[4], 16) / 255];
        }
      },
      hsl: {
        re: /^hsl\((\d{1,3}),\s*(\d{1,3})%,\s*(\d{1,3})%\)$/,
        example: ["hsl(120, 100%, 25%)", "hsl(0, 100%, 50%)"],
        toRGBA: function toRGBA(bits) {
          bits[4] = 1;
          var rgba = hslToRgb(bits);
          return [rgba.r, rgba.g, rgba.b, rgba.a];
        }
      },
      hsla: {
        re: /^hsla\((\d{1,3}),\s*(\d{1,3})%,\s*(\d{1,3})%,\s*(\d+(?:\.\d+)?|\.\d+)\s*\)/,
        example: ["hsla(120, 100%, 25%, 1)", "hsla(0, 100%, 50%, 0.5)"],
        toRGBA: function toRGBA(bits) {
          var rgba = hslToRgb(bits);
          return [rgba.r, rgba.g, rgba.b, rgba.a];
        }
      },
      hsv: {
        re: /^hsv\((\d{1,3}),\s*(\d{1,3})%,\s*(\d{1,3})%\)$/,
        example: ["hsv(120, 100%, 25%)", "hsv(0, 100%, 50%)"],
        toRGBA: function toRGBA(bits) {
          var rgb = hsvToRgb(bits);
          return [rgb.r, rgb.g, rgb.b, 1];
        }
      },
      hsb: {
        re: /^hsb\((\d{1,3}),\s*(\d{1,3})%,\s*(\d{1,3})%\)$/,
        example: ["hsb(120, 100%, 25%)", "hsb(0, 100%, 50%)"],
        toRGBA: function toRGBA(bits) {
          var rgb = hsvToRgb(bits);
          return [rgb.r, rgb.g, rgb.b, 1];
        }
      }
    }; // If this is a named color, convert it to hex

    if (namedColor.hasOwnProperty(color)) {
      color = namedColor[color];
      color.forEach(function (piece, index) {
        color[index] = ("0" + piece.toString(16)).slice(-2);
      });
      color = "#" + color.join('');
    } // Search the color definitions for a match


    for (var colorDefinition in colorDefinitions) {
      var re = colorDefinitions[colorDefinition].re;
      var processor = colorDefinitions[colorDefinition].toRGBA;
      var bits = re.exec(color);

      if (bits) {
        var channels = processor(bits);
        r = channels[0];
        g = channels[1];
        b = channels[2];
        a = +(Math.round(channels[3] + ("e+" + roundTo)) + ("e-" + roundTo));
      }
    }

    r = Math.round(r < 0 || isNaN(r) ? 0 : r > 255 ? 255 : r);
    g = Math.round(g < 0 || isNaN(g) ? 0 : g > 255 ? 255 : g);
    b = Math.round(b < 0 || isNaN(b) ? 0 : b > 255 ? 255 : b);
    a = a < 0 || isNaN(a) ? 0 : a > 1 ? 1 : a;

    switch (newColor) {
      case "hex":
        returnedColor = "#" + ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
        break;

      case "hexa":
        if (calculateOpacity) {
          var _calculateOpacityFrom = calculateOpacityFromWhite(r, g, b, a);

          var _calculateOpacityFrom2 = _slicedToArray(_calculateOpacityFrom, 4);

          r = _calculateOpacityFrom2[0];
          g = _calculateOpacityFrom2[1];
          b = _calculateOpacityFrom2[2];
          a = _calculateOpacityFrom2[3];
        }

        returnedColor = "#" + ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2) + ("0" + Math.round(255 * a).toString(16)).slice(-2);
        break;

      case "hsl":
        var hsl = rgbToHsl({
          "r": r,
          "g": g,
          "b": b
        });
        returnedColor = "hsl(".concat(hsl.h, ",").concat(hsl.s, "%,").concat(hsl.l, "%)");
        break;

      case "hsla":
        if (calculateOpacity) {
          var _calculateOpacityFrom3 = calculateOpacityFromWhite(r, g, b, a);

          var _calculateOpacityFrom4 = _slicedToArray(_calculateOpacityFrom3, 4);

          r = _calculateOpacityFrom4[0];
          g = _calculateOpacityFrom4[1];
          b = _calculateOpacityFrom4[2];
          a = _calculateOpacityFrom4[3];
        }

        var hsla = rgbToHsl({
          "r": r,
          "g": g,
          "b": b,
          "a": a
        });
        returnedColor = "hsla(".concat(hsla.h, ",").concat(hsla.s, "%,").concat(hsla.l, "%,").concat(hsla.a, ")");
        break;

      case "hsb":
        /* Same as `hsv` */
        var hsb = rgbToHsv({
          "r": r,
          "g": g,
          "b": b
        });
        returnedColor = "hsb(".concat(hsb.h, ",").concat(hsb.s, "%,").concat(hsb.v, "%)");
        break;

      case "hsv":
        var hsv = rgbToHsv({
          "r": r,
          "g": g,
          "b": b
        });
        returnedColor = "hsv(".concat(hsv.h, ",").concat(hsv.s, "%,").concat(hsv.v, "%)");
        break;

      case "rgb":
        returnedColor = "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
        break;

      case "rgba":
      /* falls through */

      default:
        if (calculateOpacity) {
          var _calculateOpacityFrom5 = calculateOpacityFromWhite(r, g, b, a);

          var _calculateOpacityFrom6 = _slicedToArray(_calculateOpacityFrom5, 4);

          r = _calculateOpacityFrom6[0];
          g = _calculateOpacityFrom6[1];
          b = _calculateOpacityFrom6[2];
          a = _calculateOpacityFrom6[3];
        }

        returnedColor = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
        break;
    }

    return returnedColor;
  }

  function calculateOpacityFromWhite(r, g, b, a) {
    var min = 0;
    a = (255 - (min = Math.min(r, g, b))) / 255;
    r = ((r - min) / a).toFixed(0);
    g = ((g - min) / a).toFixed(0);
    b = ((b - min) / a).toFixed(0);
    a = parseFloat(a.toFixed(4));
    return [r, g, b, a];
  }

  function hslToRgb(bits) {
    var rgba = {},
        hsl = {
      h: bits[1] / 360,
      s: bits[2] / 100,
      l: bits[3] / 100,
      a: parseFloat(bits[4])
    };

    if (hsl.s === 0) {
      var v = 255 * hsl.l;
      rgba = {
        r: v,
        g: v,
        b: v,
        a: hsl.a
      };
    } else {
      var q = hsl.l < 0.5 ? hsl.l * (1 + hsl.s) : hsl.l + hsl.s - hsl.l * hsl.s;
      var p = 2 * hsl.l - q;
      rgba.r = hueToRgb(p, q, hsl.h + 1 / 3) * 255;
      rgba.g = hueToRgb(p, q, hsl.h) * 255;
      rgba.b = hueToRgb(p, q, hsl.h - 1 / 3) * 255;
      rgba.a = hsl.a;
    }

    return rgba;
  }

  function rgbToHsl(rgba) {
    rgba.r = rgba.r / 255;
    rgba.g = rgba.g / 255;
    rgba.b = rgba.b / 255;
    var max = Math.max(rgba.r, rgba.g, rgba.b),
        min = Math.min(rgba.r, rgba.g, rgba.b),
        hsl = [],
        d;
    hsl.a = rgba.a;
    hsl.l = (max + min) / 2;

    if (max === min) {
      hsl.h = 0;
      hsl.s = 0;
    } else {
      d = max - min;
      hsl.s = hsl.l >= 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case rgba.r:
          hsl.h = (rgba.g - rgba.b) / d + (rgba.g < rgba.b ? 6 : 0);
          break;

        case rgba.g:
          hsl.h = (rgba.b - rgba.r) / d + 2;
          break;

        case rgba.b:
          hsl.h = (rgba.r - rgba.g) / d + 4;
          break;
      }

      hsl.h /= 6;
    }

    hsl.h = parseInt((hsl.h * 360).toFixed(0), 10);
    hsl.s = parseInt((hsl.s * 100).toFixed(0), 10);
    hsl.l = parseInt((hsl.l * 100).toFixed(0), 10);
    return hsl;
  }

  function hsvToRgb(bits) {
    var rgb = {},
        hsv = {
      h: bits[1] / 360,
      s: bits[2] / 100,
      v: bits[3] / 100
    },
        i = Math.floor(hsv.h * 6),
        f = hsv.h * 6 - i,
        p = hsv.v * (1 - hsv.s),
        q = hsv.v * (1 - f * hsv.s),
        t = hsv.v * (1 - (1 - f) * hsv.s);

    switch (i % 6) {
      case 0:
        rgb.r = hsv.v;
        rgb.g = t;
        rgb.b = p;
        break;

      case 1:
        rgb.r = q;
        rgb.g = hsv.v;
        rgb.b = p;
        break;

      case 2:
        rgb.r = p;
        rgb.g = hsv.v;
        rgb.b = t;
        break;

      case 3:
        rgb.r = p;
        rgb.g = q;
        rgb.b = hsv.v;
        break;

      case 4:
        rgb.r = t;
        rgb.g = p;
        rgb.b = hsv.v;
        break;

      case 5:
        rgb.r = hsv.v;
        rgb.g = p;
        rgb.b = q;
        break;
    }

    rgb.r = rgb.r * 255;
    rgb.g = rgb.g * 255;
    rgb.b = rgb.b * 255;
    return rgb;
  }

  function rgbToHsv(rgba) {
    rgba.r = toPercent(parseInt(rgba.r, 10) % 256, 256);
    rgba.g = toPercent(parseInt(rgba.g, 10) % 256, 256);
    rgba.b = toPercent(parseInt(rgba.b, 10) % 256, 256);
    var max = Math.max(rgba.r, rgba.g, rgba.b),
        min = Math.min(rgba.r, rgba.g, rgba.b),
        d = max - min,
        hsv = {
      "h": 0,
      "s": max === 0 ? 0 : d / max,
      "v": max
    };

    if (max !== min) {
      switch (max) {
        case rgba.r:
          hsv.h = (rgba.g - rgba.b) / d + (rgba.g < rgba.b ? 6 : 0);
          break;

        case rgba.g:
          hsv.h = (rgba.b - rgba.r) / d + 2;
          break;

        case rgba.b:
          hsv.h = (rgba.r - rgba.g) / d + 4;
          break;
      }

      hsv.h /= 6;
    }

    hsv.h = parseInt((hsv.h * 360).toFixed(0), 10);
    hsv.s = parseInt((hsv.s * 100).toFixed(0), 10);
    hsv.v = parseInt((hsv.v * 100).toFixed(0), 10);
    return hsv;
  }

  function hueToRgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }

    if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }

    if (t < 1 / 2) {
      return q;
    }

    if (t < 2 / 3) {
      return p + (q - p) * ((2 / 3 - t) * 6);
    }

    return p;
  }

  function toPercent(amount, limit) {
    return amount / limit;
  }

  module.exports = colorcolor;
  commonjsGlobal.colorcolor = module.exports;
  /* ew */
});

function generateChart(colorArray) {
  // transform the array into one of object with name and hex values
  var colorArrayWithNames = colorArray.map(function (color) {
    if (typeof color === 'string') {
      return {
        'name': color,
        'value': colorcolor_1(color, 'hex')
      };
    } else if (typeof color === 'object' && !!color.name && !!color.value) {
      return {
        'name': color.name,
        'value': colorcolor_1(color.value, 'hex')
      };
    } else {
      throw new Error("Somethin' aint right with your color array.");
    }
  }); // methods used to do it to 'em

  function getContrast(textColor, backgroundColor) {
    return index_m.hex(textColor, backgroundColor).toFixed(1);
  }

  function getScore(textColor, backgroundColor) {
    var labelRatioScore = getContrast(textColor, backgroundColor);

    if (labelRatioScore >= 7.0) {
      return 'AAA';
    } else if (labelRatioScore >= 4.5) {
      return 'AA';
    } else if (labelRatioScore >= 3.0) {
      return '18+';
    } else {
      return 'fail';
    }
  } // where the magic happens and the work actually gets done


  var colorChart = [];
  colorArrayWithNames.map(function (textColor) {
    // don't compare the color to itself
    var otherColors = colorArrayWithNames.filter(function (color) {
      return color.value !== textColor.value;
    });
    var colorObject = {
      name: textColor.name,
      value: textColor.value,
      combinationScores: []
    };
    otherColors.map(function (backgroundColor) {
      colorObject.combinationScores.push({
        name: backgroundColor.name,
        value: backgroundColor.value,
        ratio: getContrast(textColor.value, backgroundColor.value),
        score: getScore(textColor.value, backgroundColor.value)
      });
    });
    colorChart.push(colorObject);
  });
  return colorChart;
}

var colorContrastTable = generateChart;
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */

function throttle(delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}
/* eslint-disable no-undefined */

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */


function debounce(delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

var wcag = require('wcag-contrast');

var getLabelColor = function getLabelColor(color) {
  var score = wcag.hex('#fffff', color).toFixed(1);
  var labelTextColor = '#000000';

  if (score >= 3.0) {
    labelTextColor = '#ffffff';
  }

  return labelTextColor;
};

var EditValue = function EditValue(props) {
  return React.createElement('label', {
    className: 'color-contrast-table__header-label color-contrast-table__header-label--edit-value'
  }, React.createElement('span', null, props.value), React.createElement('input', {
    type: 'color',
    title: props.value + ' color',
    value: props.value,
    onChange: function onChange(event) {
      return props.onChange(props.index, event.target.value);
    },
    onBlur: function onBlur(event) {
      return props.onBlur(event);
    }
  }));
};

EditValue.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

var EditName = function EditName(props) {
  return React.createElement('label', {
    className: 'color-contrast-table__header-label color-contrast-table__header-label--edit-name'
  }, React.createElement('span', null, props.value), React.createElement('input', {
    type: 'text',
    title: props.value + ' name',
    value: props.value,
    onChange: function onChange(event) {
      return props.onChange(props.index, event.target.value);
    },
    onBlur: function onBlur(event) {
      return props.onBlur(event);
    }
  }));
};

EditName.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

var Header = function Header(props) {
  return React.createElement('th', {
    className: 'color-contrast-table__header',
    style: {
      background: props.color.value,
      color: getLabelColor(props.color.value)
    }
  }, props.editNames ? React.createElement(EditName, {
    onChange: debounce(50, props.onNamesChange),
    onBlur: props.onInputBlur,
    value: props.color.name,
    index: props.index
  }) : React.createElement('span', {
    className: 'color-contrast-table__header-label'
  }, props.color.name), props.editValues ? React.createElement(EditValue, {
    onChange: debounce(50, props.onValuesChange),
    onBlur: props.onInputBlur,
    value: props.color.value,
    index: props.index
  }) : React.createElement('span', {
    className: 'color-contrast-table__header-label'
  }, props.color.value));
};

Header.propTypes = {
  color: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  editNames: PropTypes.bool.isRequired,
  editValues: PropTypes.bool.isRequired,
  onNamesChange: PropTypes.func.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  onInputBlur: PropTypes.func
};

var Color = function Color(props) {
  return React.createElement('td', {
    className: 'color-contrast-table__color'
  }, React.createElement('div', {
    title: props.color.ratio + ' : 1',
    className: props.color.score !== 'fail' ? 'color-contrast-table__color-block' : 'color-contrast-table__color-block color-contrast-table__color-block--fail',
    style: {
      background: props.color.value,
      color: getLabelColor(props.color.value)
    }
  }, React.createElement('span', {
    className: 'color-contrast-table__color-score'
  }, props.color.score !== 'fail' ? props.color.score : 'X')));
};

Color.propTypes = {
  color: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    ratio: PropTypes.string.isRequired,
    score: PropTypes.string.isRequired
  }).isRequired
};

var Row = function Row(props) {
  return React.createElement('tr', {
    className: 'color-contrast-table__row',
    style: {
      background: props.color.value,
      color: props.color.value
    }
  }, React.createElement(Header, props), props.color.combinationScores.map(function (color, index) {
    return React.createElement(Color, {
      key: index,
      color: color
    });
  }));
};

Row.propTypes = {
  color: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Table = function Table(props) {
  return React.createElement('table', {
    className: 'color-contrast-table'
  }, React.createElement('tbody', null, props.colors.map(function (color, index) {
    return React.createElement(Row, _extends({
      key: index,
      index: index,
      color: color
    }, props));
  })));
};

Table.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired).isRequired
};

var Styles = function Styles() {
  return React.createElement('style', {
    dangerouslySetInnerHTML: {
      __html: '\n      .color-contrast-table ::-moz-color-swatch {\n        border-color: transparent;\n      }\n      .color-contrast-table ::-webkit-color-swatch {\n        border-color: transparent;\n      }\n\n      .color-contrast-table {\n        border-collapse: collapse;\n        font-size: 1em;\n      }\n\n      .color-contrast-table__row {}\n\n      .color-contrast-table__header {\n        padding: 1em;\n      }\n\n      .color-contrast-table__color {\n        padding: 1em 1em 1em 0;\n        font-size: 1.25em;\n      }\n\n      .color-contrast-table__color-block {\n        color: currentColor;\n        padding: 0 !important;\n        display: table-cell;\n        vertical-align: middle;\n        text-align: center;\n        height: 2.5em;\n        width: 2.5em;\n        min-height: 2.5em;\n        min-width: 2.5em;\n      }\n\n      .color-contrast-table__color-block--fail {\n        position: relative;\n      }\n\n      .color-contrast-table__color-block--fail span {\n        opacity: 0;\n      }\n\n      .color-contrast-table__color-block--fail:before,\n      .color-contrast-table__color-block--fail:after {\n        content: \'\';\n        display: block;\n        background: currentColor;\n        height: .125em;\n        width: 1em;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(45deg);\n      }\n\n      .color-contrast-table__color-block--fail:after {\n        transform: translate(-50%, -50%) rotate(-45deg);\n      }\n\n      .color-contrast-table__color-score {}\n\n      .color-contrast-table__header-label {\n        display: block;\n      }\n\n      .color-contrast-table__header-label + .color-contrast-table__header-label {\n        margin-top: .5em;\n      }\n\n      .color-contrast-table__header-label--edit-name,\n      .color-contrast-table__header-label--edit-value {\n        display: block;\n        position: relative;\n        padding: 0 .25em;\n      }\n\n      .color-contrast-table__header-label--edit-name span {\n        opacity: 0;\n        pointer-events: none;\n      }\n      \n      .color-contrast-table__header-label--edit-name input {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        width: 100%;\n        padding: 0;\n        border: none;\n        font-size: 1em;\n        font-weight: bold;\n        background: transparent;\n        color: currentColor;\n        text-align: center;\n        cursor: pointer;\n      }\n\n      .color-contrast-table__header-label--edit-value span {\n        pointer-events: none;\n        position: relative;\n        z-index: 2;\n      }\n\n      .color-contrast-table__header-label--edit-value input {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        height: 100%;\n        padding: 0;\n        cursor: pointer;\n        width: 100%;\n        background-color: transparent;\n        border-color: transparent;\n      }\n\n    '
    }
  });
};

var Chart = function (_React$Component) {
  inherits(Chart, _React$Component);

  function Chart(props) {
    classCallCheck(this, Chart);

    var _this = possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));

    _this.onNamesChange = function (index, value) {
      // guard against array map failing
      if (value === '') {
        value = 'Color ' + (index + 1);
      }

      var newColors = [].concat(toConsumableArray(_this.state.colors));
      newColors[index].name = value;

      _this.setState({
        colors: newColors
      });
    };

    _this.onValuesChange = function (index, value) {
      var newColors = [].concat(toConsumableArray(_this.state.colors));
      newColors[index].value = value;

      _this.setState({
        colors: newColors
      });
    };

    _this.state = {
      colors: props.colors
    };
    return _this;
  }

  createClass(Chart, [{
    key: 'render',
    value: function render() {
      var colors = colorContrastTable(this.state.colors);
      return React.createElement(React.Fragment, null, this.props.useStyles && React.createElement(Styles, null), React.createElement(Table, {
        colors: colors,
        editNames: !!this.props.editNames || !!this.props.onNamesChange,
        editValues: !!this.props.editValues || !!this.props.onValuesChange,
        onNamesChange: this.props.onNamesChange || this.onNamesChange,
        onValuesChange: this.props.onValuesChange || this.onValuesChange,
        onInputBlur: this.props.onInputBlur
      }));
    }
  }]);
  return Chart;
}(React.Component);

Chart.propTypes = {
  useStyles: PropTypes.bool,
  editNames: PropTypes.bool,
  editValues: PropTypes.bool,
  onNamesChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  onInputBlur: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  })]).isRequired).isRequired
};
export default Chart;